Application.Forms.Select = {
    ui: {
        container: '.form-control_select',
        input: '.form-control select'
    },
    ready: function () {

        this.bind();

    },
    bind: function(){

        var self = this;

        $(this.ui.input).each(function(){
            self.update(this);
        });
        $(document).on('change', this.ui.input, function(){
            self.update(this);
        });
        
    },
    update: function(input){

        if (!$(input).val() || $(input).val() === 'placeholder'){
            $(input).closest(this.ui.container).addClass('form-control_placeholder');
        }else{
            $(input).closest(this.ui.container).removeClass('form-control_placeholder');
        }

    }
}